/*
 * Barre d'achat flottante pour les gabarits Epic Box.
 *
 * Les blocs `_epic-configurator` et `_epic-standard-pack` remplacent le bloc
 * d'ajout au panier natif du thème, qui portait la barre collante. Ces pages se
 * retrouvaient donc sans aucun moyen d'acheter une fois le bouton dépassé.
 *
 * Cette barre se branche sur les points d'ancrage déjà exposés par ces deux
 * blocs (`epic-add-to-cart` et `epic-total`) et se retire d'elle-même sur les
 * gabarits où la barre native du thème est présente.
 */

const ACTIVE = 'true';
const INACTIVE = 'false';

class EpicStickyBuyBar {
  constructor(bar) {
    this.bar = bar;
    this.button = bar.querySelector('[data-ref="epic-sticky-button"]');
    this.label = bar.querySelector('[data-ref="epic-sticky-label"]');
    this.price = bar.querySelector('[data-ref="epic-sticky-price"]');

    this.target = document.querySelector('[data-ref="epic-add-to-cart"]');
    this.total = document.querySelector('[data-ref="epic-total"]');
    this.footer = document.querySelector('[data-ref="footer"]') || document.querySelector('footer');

    this.passedTarget = false;
    this.footerVisible = false;
  }

  start() {
    this.syncLabel();
    this.watchLabel();

    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      this.target.click();
    });

    this.observe();
  }

  /* IntersectionObserver plutôt qu'un écouteur de défilement : le thème place
     un `overflow` sur `body`, et selon les gabarits le conteneur qui défile
     n'est pas toujours la fenêtre. L'observateur, lui, raisonne directement en
     coordonnées d'écran et reste juste quel que soit le conteneur. */
  observe() {
    this.targetObserver = new IntersectionObserver(
      ([entry]) => {
        // Dépassé = sorti par le haut, et non « pas encore atteint ».
        this.passedTarget = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        this.render();
      },
      { threshold: 0 }
    );
    this.targetObserver.observe(this.target);

    if (this.footer) {
      this.footerObserver = new IntersectionObserver(
        ([entry]) => {
          this.footerVisible = entry.isIntersecting;
          this.render();
        },
        { threshold: 0 }
      );
      this.footerObserver.observe(this.footer);
    }

    this.render();
  }

  /* Visible une fois le bouton dépassé, masquée sur le pied de page pour ne pas
     en recouvrir les liens. */
  render() {
    const active = this.passedTarget && !this.footerVisible;
    this.bar.dataset.active = active ? ACTIVE : INACTIVE;
    this.bar.setAttribute('aria-hidden', active ? 'false' : 'true');
  }

  syncLabel = () => {
    if (this.total && this.price) this.price.innerHTML = this.total.innerHTML;
    this.button.disabled = this.target.disabled === true;

    /* L'intitulé suit celui du vrai bouton, que le marchand peut renommer
       depuis l'éditeur de thème. Le prix en est retiré : la barre l'affiche
       dans son propre élément, juste après. */
    if (!this.label) return;

    const source = this.target.querySelector('.full-add-to-cart-text, .button__content');
    if (!source) return;

    const clone = source.cloneNode(true);
    clone
      .querySelectorAll('[data-ref="epic-total"], .product-price-container, .compare-at-price')
      .forEach((node) => node.remove());

    const label = clone.textContent.trim();
    if (label) this.label.textContent = label;
  };

  /* Le prix suit la configuration en direct : chaque option cochée le met à
     jour dans le bloc d'origine, la barre reflète ce même montant. */
  watchLabel() {
    if (this.total) {
      new MutationObserver(this.syncLabel).observe(this.total, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    new MutationObserver(this.syncLabel).observe(this.target, {
      attributes: true,
      attributeFilter: ['disabled'],
    });
  }
}

function init() {
  const bar = document.querySelector('[data-ref="epic-sticky-bar"]');
  if (!bar) return;

  // Le thème rend déjà sa propre barre sur ce gabarit : ne pas en ajouter une seconde.
  if (document.querySelector('sticky-add-to-cart')) {
    bar.remove();
    return;
  }

  const target = document.querySelector('[data-ref="epic-add-to-cart"]');
  if (!target) {
    bar.remove();
    return;
  }

  new EpicStickyBuyBar(bar).start();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
